import React from "react";
import { ChevronRight } from "lucide-react";

function initiales(user) {
  return `${user.name?.[0] || ""}${user.lastName?.[0] || ""}`.toUpperCase();
}

// Deux selects par niveau (statut + collaborateur), repris de la maquette :
// le statut "À affecter" vit dans le select collaborateur (valeur __none__).
function StageFilterHeader({ status, onStatusChange, collab, onCollabChange, users }) {
  return (
    <div className="pc-filter-inner">
      <div className="pc-filter-select">
        <select value={status} onChange={(e) => onStatusChange(e.target.value)}>
          <option value="all">Tous statuts</option>
          <option value="enCours">En cours</option>
          <option value="enRetard">En retard</option>
          <option value="cloture">Clôturé</option>
        </select>
        <span className="chev">
          <ChevronRight size={12} />
        </span>
      </div>
      <div className="pc-filter-select">
        <select value={collab} onChange={(e) => onCollabChange(e.target.value)}>
          <option value="">Tous collab.</option>
          <option value="__none__">À affecter</option>
          {users.map((u) => (
            <option key={u.id} value={u.id}>
              {initiales(u)} — {u.name} {u.lastName || ""}
            </option>
          ))}
        </select>
        <span className="chev">
          <ChevronRight size={12} />
        </span>
      </div>
    </div>
  );
}

export default StageFilterHeader;
